import { render } from "./UnfoldLessHorizontal.vue?vue&type=template&id=43795753"
import script from "./UnfoldLessHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldLessHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/UnfoldLessHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43795753"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43795753', __exports__)) {
    api.reload('43795753', __exports__)
  }
  
  module.hot.accept("./UnfoldLessHorizontal.vue?vue&type=template&id=43795753", () => {
    api.rerender('43795753', render)
  })

}


export default __exports__